import apiClient from "./apiClient";

const getPreference = ({ userData, cartItems, promotionCode }) => {
    return apiClient.post(`/compras/`, {
        userData,
        cartItems,
        promotionCode,
    });
};

const previewPurchase = async (data) => {
    const response = await apiClient.post("/compras/preview", data);
    return response.data;
};


export default {
    getPreference,
    previewPurchase,
};
